import React, { Fragment, useState, useEffect } from 'react';
import './searchBar.css';

export function SearchBar({ fetchItems, setPage, updateUrl, searchQuery, setSearchQuery, fetchingData }) {
    const [sparkles, setSparkles] = useState([]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        const newSparkles = Array.from({ length: 3 }).map(() => ({
            id: Math.random().toString(36).substr(2, 9),
            left: Math.random() * 100,
            top: Math.random() * 100,
            x: Math.random() * 20 - 10,
            y: Math.random() * -20 
        }));
        setSparkles((prev) => [...prev, ...newSparkles]);
    };

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') search();
    };

    const search = () => {
        const trimmed = (searchQuery || '').trim();
        setSearchQuery(trimmed || null);
        setPage(0);
        fetchItems(null, null, 0, false, trimmed || null);
        updateUrl(null, null, trimmed || null);
    };

    useEffect(() => {
        if (sparkles.length === 0) return;
        const timeout = setTimeout(() => {
            setSparkles([]);
        }, 1000);
        return () => clearTimeout(timeout);
    }, [sparkles]);

    return (
        <Fragment>
            <div className="position-relative row search-bar">
                <div className="col-md-10 position-relative">
                    <input
                        type="text"
                        className="form-control sparkle-input"
                        name="searchQuery"
                        onChange={handleSearchChange}
                        onKeyDown={handleSearchKeyDown}
                        placeholder="Search items"
                        value={searchQuery || ''}
                    />
                    <span className="sparkles-container">
                        {sparkles.map(s => (
                            <span
                              key={s.id}
                              className="sparkle"
                              style={{
                                  left: `${s.left}%`,
                                  top: `${s.top}%`,
                                  '--x': `${s.x}px`,
                                  '--y': `${s.y}px`
                              }}
                            >
                              ✨
                            </span>
                        ))}
                    </span>
                </div>
                <div className="col-md-2 d-flex flex-column">
                    <button
                        className="btn btn-secondary w-100"
                        onClick={search}
                        disabled={fetchingData}
                    >
                        {fetchingData ? (
                            <span className="spinner-border spinner-border-sm search-bar-spinner" role="status" aria-hidden="true" />
                        ) : ('Search')}
                    </button>
                </div>
            </div>
        </Fragment>
    );
}
